import React from 'react';
import CalendarEventBadge from './CalendarEventBadge';
import { formatClassTime } from '../../utils/batchSchedule';

const MAX_VISIBLE = 2;

const CalendarCell = ({ date, isCurrentMonth, isToday, isNonWorking, events, batches = [], interviewEvents = [], onDateClick, onEventClick }) => {
  const cls = [
    'ic-cell',
    !isCurrentMonth && 'ic-cell-out',
    isToday && 'ic-cell-today',
    isNonWorking && isCurrentMonth && 'ic-cell-off',
  ].filter(Boolean).join(' ');

  const handleClick = () => { if (isCurrentMonth) onDateClick?.(date); };

  // Combine all items: institute events, class occurrences, interview events
  const interviewItems = interviewEvents.map(evt => ({ ...evt, _itemType: 'interview' }));
  const allItems = [...events, ...batches, ...interviewItems];
  const visible = allItems.slice(0, MAX_VISIBLE);
  const extra = allItems.length - MAX_VISIBLE;

  return (
    <div className={cls} onClick={handleClick}>
      <span className="ic-date">{date.getDate()}</span>
      {isCurrentMonth && allItems.length > 0 && (
        <div className="ic-cell-events">
          {visible.map((item) => (
            item.type && !item._itemType ? (
              <CalendarEventBadge key={item._id} event={item} onClick={onEventClick} />
            ) : item._itemType === 'interview' ? (
              <CalendarEventBadge key={item._id} event={item} onClick={null} isInterview />
            ) : (
              // A class occurrence: one batch on this date. Shows the time when
              // the batch has one, so the month view says as much as it can.
              <div
                key={item.key}
                className="ic-batch-badge"
                title={`${item.batch.name} (${item.batch.batchType})${item.timed ? ` · ${formatClassTime(item.startTime)} – ${formatClassTime(item.endTime)}` : ' · class time not set'}`}
              >
                {item.timed && <span className="ic-batch-badge__time">{formatClassTime(item.startTime)}</span>}
                {item.batch.name}
              </div>
            )
          ))}
          {extra > 0 && <span className="ic-cell-more">+{extra} more</span>}
        </div>
      )}
    </div>
  );
};

export default CalendarCell;
